import R from 'ramda';

export const matchImageWithBreakpoint = ({ currentBreakpoint, image }) =>
  R.or(
    R.path(
      [0, 'src'],
      R.filter(
        R.propEq('name', currentBreakpoint),
        R.propOr({ imageSrcSet: [] }, 'imageSrcSet', image)
      )
    ),
    R.prop('imageSrc', image)
  );
